var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2692_59357)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.682918 9.8539C0.78169 9.9477 0.912704 10 1.04892 10C1.18513 10 1.31615 9.9477 1.41492 9.8539L5.69642 5.7219C5.79226 5.63082 5.86857 5.5212 5.92072 5.3997C5.97286 5.2782 5.99976 5.14737 5.99976 5.01515C5.99976 4.88294 5.97286 4.7521 5.92072 4.63061C5.86857 4.50911 5.79226 4.39949 5.69642 4.3084L1.38392 0.145904C1.18392 -0.0465961 0.859917 -0.0490957 0.656917 0.140904C0.60777 0.186169 0.568452 0.241055 0.541405 0.302152C0.514358 0.363249 0.500159 0.429254 0.499691 0.496068C0.499222 0.562883 0.512492 0.62908 0.538679 0.690551C0.564866 0.752022 0.603409 0.807454 0.651917 0.853405L4.59842 4.6619C4.64638 4.70745 4.68457 4.76227 4.71066 4.82305C4.73676 4.88382 4.75022 4.94927 4.75022 5.0154C4.75022 5.08154 4.73676 5.14699 4.71066 5.20776C4.68457 5.26853 4.64638 5.32336 4.59842 5.3689L0.683417 9.1474C0.635472 9.1929 0.597291 9.24769 0.5712 9.30842C0.545109 9.36915 0.531654 9.43456 0.531654 9.50065C0.531654 9.56675 0.545109 9.63216 0.5712 9.69289C0.597291 9.75362 0.634973 9.8084 0.682918 9.8539Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2692_59357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.5,
    height: 10,
    fill: "white",
    transform: "translate(6 10) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWhite);
export default __webpack_public_path__ + "static/media/right-arrow-white.60fb65c515bfe4a6f2f86dc978428e37.svg";
export { ForwardRef as ReactComponent };